//MODIFICA AI 29/01/26
(() => {
  const CART_UPDATE_URL = '/cart/update.js';

  function ymd(date) {
    const yyyy = date.getFullYear();
    const mm = String(date.getMonth() + 1).padStart(2, '0');
    const dd = String(date.getDate()).padStart(2, '0');
    return `${yyyy}-${mm}-${dd}`;
  }

  function tomorrowYMD() {
    const t = new Date();
    t.setDate(t.getDate() + 1);
    return ymd(t);
  }

  async function updateCartAttributes(attrs) {
    await fetch(CART_UPDATE_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ attributes: attrs })
    });
  }

  function isVisible(el) {
    return !!(el && (el.offsetParent !== null || el.getClientRects().length));
  }

  function getActiveRoot() {
    const roots = Array.from(document.querySelectorAll('[data-cart-custom-fields]'));
    const visibleRoots = roots.filter(isVisible);
    return visibleRoots[visibleRoots.length - 1] || roots[0] || null;
  }

  function initRoot(root) {
    if (!root || root.dataset.bound === '1') return;
    root.dataset.bound = '1';

    const dateInput  = root.querySelector('[data-preferred-date]');
    const slotInputs = root.querySelectorAll('input[type="radio"][data-slot]');
    const msgInput   = root.querySelector('[data-card-message]');
    const dateErr    = root.querySelector('[data-date-error]');
    const slotErr    = root.querySelector('[data-slot-error]');
    const warnBox    = root.querySelector('[data-checkout-warning]');

    if (!dateInput || !slotInputs.length || !msgInput) return;

    const minDate = tomorrowYMD();
    dateInput.min = minDate;

    // Normalizza eventuale valore salvato non valido
    if (dateInput.value && dateInput.value < minDate) dateInput.value = '';

    function selectedSlot() {
      const checked = Array.from(slotInputs).find(i => i.checked);
      return checked ? checked.value : '';
    }

    function show(el, on) {
      if (!el) return;
      el.style.display = on ? 'block' : 'none';
    }

    function openDatePicker() {
      dateInput.focus();
      if (typeof dateInput.showPicker === 'function') {
        try { dateInput.showPicker(); } catch (e) {}
      }
    }

    function validate({ showErrors = false, focus = false } = {}) {
      const dateOk = !!dateInput.value && dateInput.value >= minDate;
      const slotOk = !!selectedSlot();

      if (showErrors) {
        show(dateErr, !dateOk);
        show(slotErr, !slotOk);
        show(warnBox, !(dateOk && slotOk));
      } else {
        show(dateErr, false);
        show(slotErr, false);
        show(warnBox, false);
      }

      if (focus && !(dateOk && slotOk)) {
        root.scrollIntoView({ behavior: 'smooth', block: 'center' });
        if (!dateOk) openDatePicker();
        else if (!slotOk) slotInputs[0].focus();
      }

      return dateOk && slotOk;
    }

    let timer = null;
    function scheduleSave() {
      clearTimeout(timer);
      timer = setTimeout(async () => {
        const attrs = {
          'Data consegna/ritiro': dateInput.value || '',
          'Fascia oraria': selectedSlot() || '',
          'Testo biglietto': msgInput.value || ''
        };
        try { await updateCartAttributes(attrs); } catch (e) {}
      }, 250);
    }

    // Espone validate al guard globale
    root.__cartFieldsValidate = validate;

    // UX: non mostra errori finché non provano ad andare al checkout
    validate({ showErrors: false });

    dateInput.addEventListener('change', () => { validate({ showErrors: false }); scheduleSave(); });
    slotInputs.forEach(i => i.addEventListener('change', () => { validate({ showErrors: false }); scheduleSave(); }));
    msgInput.addEventListener('input', scheduleSave);

    // Se focus sulla data vuota, apri picker
    dateInput.addEventListener('focus', () => { if (!dateInput.value) openDatePicker(); });
  }

  function scanAndInit() {
    document.querySelectorAll('[data-cart-custom-fields]').forEach(initRoot);
  }

  // Init iniziale
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scanAndInit);
  } else {
    scanAndInit();
  }

  // Re-init per aggiornamenti AJAX (drawer/cart)
  const obs = new MutationObserver(scanAndInit);
  obs.observe(document.documentElement, { childList: true, subtree: true });

  // Guard globale: intercetta QUALSIASI trigger di checkout (link o bottone)
  if (!window.__cartFieldsCheckoutGuardBound) {
    window.__cartFieldsCheckoutGuardBound = true;

    document.addEventListener('click', (e) => {
      const el = e.target.closest(
        'a[href*="/checkout"], a[href*="checkout"], button[name="checkout"], input[name="checkout"], button[class*="checkout"], a[class*="checkout"], [data-checkout]'
      );
      if (!el) return;

      const root = getActiveRoot();
      if (!root || typeof root.__cartFieldsValidate !== 'function') return;

      const ok = root.__cartFieldsValidate({ showErrors: true, focus: true });
      if (!ok) {
        e.preventDefault();
        e.stopPropagation();
        if (typeof e.stopImmediatePropagation === 'function') e.stopImmediatePropagation();
      }
    }, true);
  }
})();


//MODIFICA AI 29/01/26